// index.js
import http from "./request";

const validateUser = function (userId, token) {
  const params = { userId: userId + "", token: token };
  return http.apiPost("Account/ValidateUser", params);
};

const loginByCaptcha = function (phone, captcha) {
  const params = { phoneNumber: phone + "", captcha: captcha };
  return http.apiPost("Account/LoginByCaptcha", params);
};

const loginByPassword = function (account, password) {
  const params = { account: account + "", password: password };
  return http.apiPost("Account/LoginByPassword", params);
};

const sendRegistCaptcha = function (phone) {
  const params = { phoneNumber: phone + "" };
  return http.apiPost("Account/SendRegistCaptcha", params);
};

const registAndLoginByPhone = function (phone, captcha) {
  const params = { phoneNumber: phone + "", captcha: captcha };
  return http.apiPost("Account/RegistAndLoginByPhone", params);
};

const isPhoneBinded = function IsPhoneBinded(token) {
  const params = { value: token };
  return http.apiPost("Weixin/IsPhoneBindedByToken", params);
};

const getPhoneBindingInfo = function GetPhoneBindingInfo(token) {
  const params = { value: token };
  return http.apiPost("Weixin/GetPhoneBindingInfo", params);
};

const bindGongZongToPhone = function (userId, phone, captcha) {
  const params = {
    accountId: userId,
    phoneNumber: phone + "",
    captcha: captcha,
  };
  return http.apiPost2("Weixin/BindGongZongToPhone", params);
};

export default {
  validateUser,
  loginByCaptcha,
  loginByPassword,
  sendRegistCaptcha,
  registAndLoginByPhone,
  isPhoneBinded,
  bindGongZongToPhone,
  getPhoneBindingInfo,
};
